export enum CATEGORIES_SELECT_VALUE_KEYS {
  ID = 'id',
  NAME = 'name'
}
